// @flow
import { pdfjs } from 'react-pdf';

// Update PDF.js worker configuration with fallback options
export const setupPdfWorker = (): boolean => {
	try {
		const cdnWorkerUrl = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;
		// const localWorkerUrl = `${window.location.origin}/pdf.worker.min.js`;

		pdfjs.GlobalWorkerOptions.workerSrc = cdnWorkerUrl;
	} catch (error) {
		// eslint-disable-next-line no-console
		console.error('Failed to setup PDF.js worker:', error);
		return false;
	}
	return true;
};

export const createPdfUrl = (blob: Blob): string => {
	return window.URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }));
};

export const revokePdfUrl = (url: string): void => {
	window.URL.revokeObjectURL(url);
};
